<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="任务处理">

        <el-divider>申 请 表 单</el-divider>
        <OfficialEdit :type="taskStep" :row="form" :isReadOnly="true" :isShowClose="false"></OfficialEdit>
        <el-divider>审 批 意 见</el-divider>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
          <el-row :gutter="35">
            <template v-if="taskStep == 'hrApprove' || taskStep == 'gmApprove'">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb0">
                <el-form-item label="转正工资" prop="officialSalary" :rules="{required: true ,message: '转正工资不能为空', trigger: 'blur' }">
                  <el-input :readonly="isReadOnly" v-model="form.officialSalary" placeholder="请输入转正工资"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb0">
                <el-form-item label="实际转正时间" prop="realDate">
                  <el-date-picker :readonly="isReadOnly" clearable size="small"
                                  v-model="form.realDate"
                                  type="date"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择实际转正时间">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </template>
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb0">
              <el-form-item label="是否同意" prop="approved" :rules="{required: true,message: '是否同意不能为空', trigger: 'blur' }">
                <el-radio-group :readonly="isReadOnly" v-model="form.approved">
                  <el-radio label="0">不同意</el-radio>
                  <el-radio label="1">同意</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb0">
              <el-form-item label="审批意见" prop="approved">
                <el-input :readonly="isReadOnly" v-model="form.content" type="textarea" placeholder="请填写审批意见"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24"
                     :sm="24" :md="24" :lg="24" :xl="24" class="mb0" STYLE="text-align: center">
              <el-form-item>
                <el-button type="primary" v-if="isShowSubmit"  @click="submitForm"
                           v-permission="['/bpm/official/apply', '/bpm/official/approve']">提 交
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="历史跟踪">
        <el-steps :active="stepActive" simple finish-status="success">
          <el-step :title="stepTitle(item)" icon="el-icon-edit" v-for="(item) in handleTask.historyTask"></el-step>
        </el-steps>
        <br/>
        <el-steps direction="vertical" :active="stepActive" space="65px">
          <el-step :title="stepTitle(item)" :description="stepDes(item, handleTask)"
                   v-for="(item) in handleTask.historyTask"></el-step>
        </el-steps>
      </el-tab-pane>
      <el-tab-pane label="流程图">
        <div v-html="highlightSvgUrl"></div>
      </el-tab-pane>
    </el-tabs>

  </div>

</template>

<script>
import permission from '@/directive/permission/index.js'; // 权限判断指令
import OfficialEdit from "./officialEdit";
import {completeTask, getOfficial} from "@/api/bpm/official.js";
import {taskSteps, getHighlightImg} from "@/api/bpm/todoList.js";
import {getStepDes, getStepTitle} from "@/views/pages/bpm/bpmUtils";

export default {
  name: "approve",
  components: {
    OfficialEdit,
  },
  directives: {permission},
  computed: {
    stepActive: function () {
      let idx = 0;
      for (let i = 0; i < this.handleTask.historyTask.length; i++) {
        if (this.handleTask.historyTask[i].status === 1) {
          idx = idx + 1;
        } else {
          break;
        }
      }
      return idx;
    },
    stepTitle() {
      return getStepTitle;
    },
    stepDes() {
      return getStepDes;
    }
  },

  data() {
    return {
      handleTask: {
        historyTask: []
      },
      highlightSvgUrl: "",
      isReadOnly: false,
      isShowSubmit: true,
      row: null,
      taskId: null,
      businessKey: null,
      processInstanceId: null,
      taskStep: null,
      form: {},
      // 表单校验
      rules: {},
      selfAppraisal: {
        content: null,
      },

    }
  },
  created() {
    // user router
    console.log("this.$route.query=");
    console.log(this.$route.query);
    const {businessKey, id, processInstanceId, taskDefinitionKey} = this.$route.query;
    if(!processInstanceId){
      console.log("processInstanceId is empty...");
      return;
    }
    if(!businessKey){
      console.log("businessKey is empty...");
      return;
    }
    this.businessKey = businessKey;
    this.taskStep = taskDefinitionKey;
    this.taskId = id;
    this.processInstanceId = processInstanceId;
    this.getHighlightImg(this.processInstanceId);
    getOfficial(businessKey).then(response => {
      this.form = response.data;
      if (!this.form.selfAppraisal) {
        this.form.selfAppraisal = this.selfAppraisal;
      }
    });

    taskSteps(this.processInstanceId).then(response => {
      this.handleTask = response.data;
    });


  },
  methods: {
    getHighlightImg(processInstanceId) {
      getHighlightImg(processInstanceId).then(response => {
        // console.log(response)
        this.highlightSvgUrl = response.data;
      })
    },
    close() {

    },
    // 取消按钮
    cancel() {
      // this.open = false;
      // this.reset();
      this.$emit("close", {refresh: false, isSuccess: true});
    },

    /** 提交按钮 */
    submitForm() {
      this.form.taskId = this.taskId;
      completeTask(this.form).then(response => {
        this.form = response.data;
        this.msgSuccess("审批提交成功");
        this.isShowSubmit = false;
        this.bus.$emit('onCurrentContextmenuClick', {
          id: 1,
          path: this.$route.path,
        });
      });
    },

  },
}
</script>

<style scoped>

</style>
